(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-access-gate"] && !Shopify.designMode) return;
  try {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Cart apps (Rebuy) post their own cart update alongside ours. On a visitor's
  // first cart write the two requests can create separate carts, so keep saving
  // until the code is on the cart the cookie points to, read twice in a row.
  async function saveAccessCode(form, code) {
    const { cartUrl, cartUpdateUrl, accessKey } = form.dataset;
    let confirmedToken = null;

    for (let attempt = 0; attempt < 8; attempt += 1) {
      const cart = await fetch(`${cartUrl}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } }).then(
        (response) => response.json()
      );

      if (cart.attributes[accessKey] === code) {
        if (cart.token === confirmedToken) return;
        confirmedToken = cart.token;
      } else {
        confirmedToken = null;
        const response = await fetch(`${cartUpdateUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [accessKey]: code } }),
        });
        if (!response.ok) throw new Error(response.statusText);
      }

      await wait(400);
    }

    throw new Error('Passcode was not saved to the cart');
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-access-gate]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = document.getElementById('ProductAccessGateError');
    button.disabled = true;

    saveAccessCode(form, form.elements.product_access_code.value)
      .then(() => window.location.reload())
      .catch(() => {
        error.textContent = form.dataset.requestError;
        button.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
